export const listStyles = 'list-disc text-uiMidDark pl-8 mb-4';
export const container = 'min-h-full bg-white flex flex-1 flex-col';
export const wrapper = 'pt-6 p-3';
export const formButton = 'w-full mt-5 mb-5';
